import React, { useState, useEffect } from 'react';
import { textLang } from 'services/Lang';

const BirthdayField = ({ value, onChange, editMode }) => {
  // Парсим текущее значение даты, если оно есть
  const initialDate = value ? new Date(value) : null;
  const [day, setDay] = useState(initialDate ? initialDate.getDate() : '');
  const [month, setMonth] = useState(initialDate ? initialDate.getMonth() + 1 : '');
  const [year, setYear] = useState(initialDate ? initialDate.getFullYear() : '');

  // Генерим массив годов от 1900 до (текущий - 18)
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let y = currentYear - 18; y >= 1900; y--) {
    years.push(y);
  }

  // Дни (1–31)
  const days = Array.from({ length: 31 }, (_, i) => i + 1);

  // Месяцы (1–12)
  const months = Array.from({ length: 12 }, (_, i) => i + 1);

  // Каждый раз, когда меняется день/месяц/год → собирать дату
  useEffect(() => {
    if (day && month && year) {
      const d = new Date(year, month - 1, day);
      onChange({ target: { value: d } });
    }

    if(!day || !month || !year){
      onChange({ target: { value: 0 } });
    }
  }, [day, month, year]);

  if (!editMode) {
    return <span>{value || '—'}</span>;
  }

  return (
    <div style={{ display: 'flex', gap: '8px', justifyContent: 'space-between' }}>
      {/* День */}
      <select style={{ width: '100%'}} value={day} onChange={(e) => setDay(Number(e.target.value))}>
        <option value="">{textLang('day')}</option>
        {days.map((d) => (
          <option key={d} value={d}>{d}</option>
        ))}
      </select>

      {/* Месяц */}
      <select style={{ width: '100%' }} value={month} onChange={(e) => setMonth(Number(e.target.value))}>
        <option value="">{textLang('month')}</option>
        {months.map((m) => (
          <option key={m} value={m}>{m}</option>
        ))}
      </select>

      {/* Год */}
      <select style={{ width: '100%' }} value={year} onChange={(e) => setYear(Number(e.target.value))}>
        <option value="">{textLang('year')}</option>
        {years.map((y) => (
          <option key={y} value={y}>{y}</option>
        ))}
      </select>
    </div>
  );
};

export default BirthdayField;
